import { render } from "./agregarDocumentoModal.vue?vue&type=template&id=8621b45a&scoped=true"
import script from "./agregarDocumentoModal.vue?vue&type=script&lang=js"
export * from "./agregarDocumentoModal.vue?vue&type=script&lang=js"

import "./agregarDocumentoModal.vue?vue&type=style&index=0&id=8621b45a&lang=css"
import "./agregarDocumentoModal.vue?vue&type=style&index=1&id=8621b45a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\reclasin-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8621b45a"]])

export default __exports__